module.exports = __webpack_public_path__ + "img/NXN2.691296bb.png";